module.exports = __webpack_public_path__ + "media/movie.304c5a24.mp4";